import { render, staticRenderFns } from "./ControlsOverlay.vue?vue&type=template&id=78d96302"
import script from "./ControlsOverlay.vue?vue&type=script&lang=js"
export * from "./ControlsOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports